var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "subTab": "",
      "sh": "About us",
      "index": "04",
      "total": "04",
      "tabActive": "Location",
      "bg": "/images/sub/visual/sv1.jpg"
    }
  }), _c('section', {
    staticClass: "section section--first pb-0"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h2', {
    staticClass: "tit tit--lg dot-tit"
  }, [_vm._v("Location")])]), _c('v-tabs', {
    staticClass: "v-tab--primary",
    attrs: {
      "grow": "",
      "show-arrows": "",
      "center-active": ""
    }
  }, [_c('v-tab', {
    attrs: {
      "to": "/aboutus/location/paju"
    }
  }, [_c('span', [_vm._v("Paju Main Office")])]), _c('v-tab', {
    attrs: {
      "to": "/aboutus/location/ulsan"
    }
  }, [_c('span', [_vm._v("Ulsan Branch")])])], 1)], 1)], 1), _c('section', {
    staticClass: "section section--last pt-0"
  }, [_c('v-container', [_c('div', {
    staticClass: "h-400px h-lg-600px"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "id": "map"
    }
  })]), _c('top-image', {
    attrs: {
      "tit": "Contact us",
      "image": "/images/sub/aboutus/paju-img.jpg"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/icon/icon-tel.png"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": ""
    }
  }, [_c('span', [_vm._v("+82 31 906 9053 / 4")])])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/icon/icon-mail.png"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": ""
    }
  }, [_c('span', [_vm._v("info@kiesys.co.kr")])])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/icon/icon-address.png"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": ""
    }
  }, [_c('span', [_vm._v("17, Gyoha-ro 863 beon-gil Paju-si, Gyeonggi-do, Korea (10880)")])])], 1)], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }